var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "photo-lower-bar-button-group" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.canDeleted,
            expression: "canDeleted"
          }
        ],
        staticClass: "photo-lower-bar-button",
        on: {
          click: function($event) {
            return _vm.deleteSelectedPlane()
          }
        }
      },
      [
        _c("SVGPhotoDelete", { staticClass: "lb-svg" }),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "photo-lower-bar-button-text extra-left-padding" },
          [_vm._v("Удалить")]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.platbandCompatible,
            expression: "platbandCompatible"
          }
        ],
        staticClass: "photo-lower-bar-button",
        on: {
          click: function($event) {
            return _vm.addPlatband()
          }
        }
      },
      [
        _c("SVGAddAdditionalAuto", { staticClass: "lb-svg" }),
        _vm._v(" "),
        _c(
          "span",
          { staticClass: "photo-lower-bar-button-text extra-left-padding" },
          [_vm._v("Добавить наличник")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }